import { Injectable } from '@angular/core';
import { AddBeneficiaryStep } from '../constants/add-beneficiary-constant';

@Injectable({
  providedIn: 'root'
})
export class NewRecipientStep1Model {
  recipientType: number;
  recipientName: string;
  email: string;
  notification = 'no';
  recipientCountry = {
    id: null,
    name: ''
  };
  recipientAddress1: '';
  recipientAddress2: '';
  country = {
    id: '',
    code: '',
    name: '',
    isEurozone: false,
    hasUseIBAN: false,
    isFasterPay: false
  };
  currency = {
    id: '',
    code: ''
  };
  countries = [];
  beneficiaryType = '';
  beneficiaryCity: '';
  beneficiaryState: '';
  beneficiaryPostCode: '';
  beneficiaryTaxId: '';

  acceptSWIFT: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NewRecipientStep2Model {
  IBAN: string;
  sortCode: string;
  accountNumber: string;
  bankCode: string;
  SWIFTCode: string;

  BIC: string;
  bankName: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  stateProvince: string;
  zipPostalCode: string;
  reference: string;
  mandate: string;
  isSendOneOffPayment: boolean;

  purposeOfPayment: string;

  bankAccountType?: string;

  acceptSEPA: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class RemitterDetails {
  ultimateRemitterType: Number;
  ultimateRemitterCompanyName: string;
  ultimateRemitterFirstName: string;
  ultimateRemitterLastName: string;
  ultimateRemitterAddress: string;
  ultimateRemitterCity:  string;
  ultimateRemitterPostCode: string;
  ultimateRemitterState: string;
  ultimateRemitterCountryId: string;
  ultimateRemitterCompanyNumber: string;
  ultimateRemitterDOB: string;
}

@Injectable({
  providedIn: 'root'
})
export class NewRecipientModel {
  step1 = new NewRecipientStep1Model();
  step2 = new NewRecipientStep2Model();

  // Inforamtion of new ultimate remitter entered by user
  remitterDetail = new RemitterDetails();

  // ID of an existing ultimate remitter selected by user
  existingUltimateRemitterIdSelected: string;

  currentStep = AddBeneficiaryStep.STEP1;
  bankConfig = {
    acceptBankCodeOnly: [],
    require9DigitBankCode: [],
    requireAccountType: [],
    requireStateProvince: [],
    requireTaxId: []
  };

  clear() {
    this.step1 = new NewRecipientStep1Model();
    this.step2 = new NewRecipientStep2Model();
    this.remitterDetail = new RemitterDetails();
    this.currentStep = AddBeneficiaryStep.STEP1;
  }
}
